/**
 * Created by Mark on 10/27/19.
 */


/**
 * Created by mark on 19/02/2018.
 */


/**
 * Created by mark on 29/01/2018.
 */



import React  from 'react';
import {Button , Breadcrumb , FormGroup , ControlLabel , Tabs , Tab , Row , Col , NavItem , Nav} from 'react-bootstrap';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import ScoresService from '../../../services/reports-service.js';
import Translation from '../../../store/internationalization-store.js';
import Downloader from '../../../classes/download.js';


let ranges = [
    {thresholdLower:70 , thresholdHigher:100 , total:0 , color:"#88c057"},
    {thresholdLower:40 , thresholdHigher:70  , total:0 , color:"#ffcc66"},
    {thresholdLower:1 , thresholdHigher:40   ,  total:0 , color:"#ed7161"},
    {thresholdLower:0 , thresholdHigher:0   ,  total:0 , color:"#ffffff"}
];

export default class DetailTable extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            headers:[],
            data:[],
        }
    }

    componentDidMount(){

        ScoresService.getExamDetailed(this.props.module['uid'] , this.props.classID , this.props.set , this.props.due , this.props.language , this.props.studentID).then(function(response){

            this.setState({
                headers:response.headers,
                data:response.data,
                name:this.props.module.title
            })

        }.bind(this));
    }

    formatterColor(cell){


        return {
            background:this.getBackgroundColor(cell)
        }
    }

    getBackgroundColor(value){
        var test = function(value , thresholdLower , thresholdHigher){

            value = String(value).replace('%' , '');

            console.log(value)
            if(value == 0 && thresholdLower == 0)
            {
                return true;
            }

            return value > Number(thresholdLower) && value <= Number(thresholdHigher)
        };


        let col;


        for(var r = 0 ; r < ranges.length; r++)
        {
            if(test(value , ranges[r].thresholdLower , ranges[r].thresholdHigher))
            {
                col = ranges[r].color
                break;
            }
        }


        return col;
    }

    componentWillReceiveProps(props){
        this.props = props;
    }

    handelDownloadRequest(){
        var csv = [];
        var row = ["" , Translation.getModule('no-index-module-'+this.props.name , this.props.name)];
        csv.push(row.join(","));

        var row = ["" , "Reading" , "" , "" , "Writing" , "Speaking" , "" , "Listening" , "" , ""];
        csv.push(row.join(","));

        var row = ["" , "Gap Fill" , "True or False" , "Multiple Choice" , "Open Writing" , "Photo" , "Question" , "True or False" , "Multiple Choice" , "Who Said What"];
        csv.push(row.join(","));

        for(var idx = 0 ; idx < this.props.data.length; idx++)
        {
            var _row = this.props.data[idx];
            var row = [];
            row.push(_row.name);


            row.push(_row['203']);
            row.push(_row['200']);
            row.push(_row['201']);
            row.push(_row['206']);
            row.push(_row['208']);
            row.push(_row['207']);
            row.push(_row['202']);
            row.push(_row['204']);
            row.push(_row['205']);

            csv.push(row.join(","));
        }


        (new Downloader()).download_csv(csv.join("\n"));
    }

    getTableData(){
        return this.state.data || [];
    }

    render(){

        const tableOptions = {
            page: 1,  // which page you want to show as default
            sizePerPage: 30,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationShowsTotal: false,
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            hideSizePerPage: true,
            alwaysShowAllBtns: true, // Always show next and previous button
            withFirstAndLast:true,
            firstPage: '...', // First page button text
            lastPage: '...', // Last page button text
        };


        var headers = [];

        for(var idx = 0;  idx < this.state.headers.length; idx++)
        {
            headers.push(
                <TableHeaderColumn row='2' rowSpan='1' dataField={this.state.headers[idx].gameUid} >
                    <small>
                        {Translation.getModule(this.state.headers[idx].title , this.state.headers[idx].title)}
                    </small>
                </TableHeaderColumn>
            );
        }


        let body = [];

        var data = this.getTableData();

        for(var i = 0; i < data.length; i++)
        {
            body.push(
                <tr><td >{data[i].name}</td>
                <td style={ this.formatterColor(data[i]['203']) }>{data[i]['203']}</td>
                    <td style={ this.formatterColor(data[i]['200']) }>{data[i]['200']}</td>
                    <td style={ this.formatterColor(data[i]['201']) }>{data[i]['201']}</td>
                    <td style={ this.formatterColor(data[i]['206']) }>{data[i]['206']}</td>
                    <td style={ this.formatterColor(data[i]['208']) }>{data[i]['208']}</td>
                    <td style={ this.formatterColor(data[i]['207']) }>{data[i]['207']}</td>
                    <td style={ this.formatterColor(data[i]['202']) }>{data[i]['202']}</td>
                    <td style={ this.formatterColor(data[i]['204']) }>{data[i]['204']}</td>
                    <td style={ this.formatterColor(data[i]['205']) }>{data[i]['205']}</td>
                </tr>
            )
        }

        return <table class="table table-bordered">
                <thead>
                <tr>
                    <th rowSpan='3'></th>
                    <th colSpan={9}>{Translation.getModule(this.state.name , this.state.name)}</th>
                </tr>
                <tr>
                    <th colSpan='3'>Reading</th>
                    <th colSpan='1'>Writing</th>
                    <th colSpan='2'>Speaking</th>
                    <th colSpan='3'>Listening</th>
                </tr>
                <tr>
                    <th>Gap Fill</th>
                    <th>True or False</th>
                    <th>Multiple Choice</th>
                    <th>Open Writing</th>
                    <th>Photo</th>
                    <th>Question</th>
                    <th>True or False</th>
                    <th>Multiple Choice</th>
                    <th>Who Said What</th>
                </tr>
                </thead>
            <tbody>
            {body}
            </tbody>
        </table>
    }

}